import React, { useState } from 'react';

import {
  CalculatorFormInputData,
  CalculatorFormInputs,
} from './CalculatorFormInputs';
import { EmptyChart } from './EmptyChart';
import {
  BottomPanel,
  calculatePaychecks,
  PaycheckCard,
  PaycheckChartData,
  TopPanel,
} from './paycheckCalculatorUtils';
import { PaycheckChart } from './PaycheckChart';
import { PaycheckValueProps } from './PaycheckValueProps';

export const PaycheckCalculator = () => {
  const [chartData, updateChartData] = useState<PaycheckChartData[] | null>(
    null,
  );
  const [
    calculatorFormData,
    updateCalculatorFormData,
  ] = useState<CalculatorFormInputData | null>(null);
  const onSubmit = (calculatorFormInputData: CalculatorFormInputData) => {
    const { retirementSavings, retirementAge } = calculatorFormInputData;
    const paycheckData = calculatePaychecks(retirementSavings, retirementAge);
    updateChartData(paycheckData);
    updateCalculatorFormData(calculatorFormInputData);
  };

  return (
    <PaycheckCard>
      <TopPanel>
        {chartData ? (
          <PaycheckChart
            paycheckData={chartData}
            retirementSavings={calculatorFormData?.retirementSavings || 0}
          />
        ) : (
          <EmptyChart />
        )}
      </TopPanel>
      <BottomPanel>
        {chartData ? (
          <PaycheckValueProps
            resetForm={() => updateChartData(null)}
            {...calculatorFormData}
          />
        ) : (
          <CalculatorFormInputs onSubmit={onSubmit} />
        )}
      </BottomPanel>
    </PaycheckCard>
  );
};
